import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Global } from "../global";
import { Router } from "@angular/router";
import { Http } from '@angular/http';
import { Headers } from '@angular/http';

@Injectable()
export class ApiSemLoginService {
  headers = new Headers();
  constructor(
    private http: HttpClient,
    public global: Global,
    public router: Router,
    private http_: Http
  ) {
    try {
      this.headers.append("Authorization", "Bearer " + this.global.token_acesso);
      this.headers.append('Content-Type', 'application/json');
    } catch (err) {
      this.router.navigate(["/login"]);
    }
  }

  Get(path) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.global.apiUrl + path, {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  GetOne(path, id) {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.global.apiUrl + this.global.formatApiPath([path, id]), {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Post(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .post(this.global.apiUrl + path, JSON.stringify(data), {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Put_current(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .put(this.global.apiUrl + path, JSON.stringify(data), {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  PostAuths(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .post(this.global.apiUrl + path, JSON.stringify(data), {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
          // .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Put(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.global.apiUrl + this.global.formatApiPath([path, data.uuid]),
          JSON.stringify(data),
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  PutCliente(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.global.apiUrl + path, JSON.stringify(data),
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Put2(path, data) {
    return new Promise((resolve, reject) => {
      this.http
        .put(
          this.global.apiUrl + this.global.formatApiPath([path, "id?id=" + data.uuid]),
          JSON.stringify(data),
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Delete(path, id) {
    return new Promise((resolve, reject) => {
      this.http
        .delete(this.global.apiUrl + this.global.formatApiPath([path, id]), {
          headers: new HttpHeaders()
            .set("Content-Type", "application/json")
            .set("Authorization", "Bearer " + this.global.token_acesso)
        })
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Patch(path, id, status) {
    return new Promise((resolve, reject) => {
      this.http
        .patch(
          this.global.apiUrl + path + "/" + id + "?status=" + status,
          {},
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  Patch_body(path, dado) {
    return new Promise((resolve, reject) => {
      this.http
        .patch(
          this.global.apiUrl + path,
          dado,
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }

  mudarSenha(path, id, senha_antiga, senha_nova) {
    return new Promise((resolve, reject) => {
      this.http
        .patch(
          this.global.apiUrl + path + "/" + id + "?" + "senhaNova=" + senha_nova + "&senhaAntiga=" + senha_antiga,
          {},
          {
            headers: new HttpHeaders()
              .set("Content-Type", "application/json")
              .set("Access-Control-Allow-Origin", "*")
              .set("Authorization", "Bearer " + this.global.token_acesso)
          }
        )
        .subscribe(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
    });
  }
  

}



// WEBPACK FOOTER //
// ./src/app/services/apiSemLogin.service.ts